import { SceneryStep } from './scenery-step';

export class Scenery {
    Id: number;
    Name: '';
    Description: '';
    UserId?: number;
    SiteId: number;
    Steps?: SceneryStep[];

    constructor(siteId: number) {
        this.SiteId = siteId;
        this.Name = '';
        this.Description = '';
    }
}

